// extracted by mini-css-extract-plugin
module.exports = {"btn":"play_btn__8cw2o","circle":"play_circle__D3lg8","play":"play_play__Tcvx1"};